import { Box, Typography } from '@material-ui/core'

import { getSegmentValue } from 'components/SegmentSelector/segment-service'

import { withContext } from '../Context'
import CheckList from '../components/CheckList'

const SegmentName = 'Ethnicity'

const ETHNICITY_OPTIONS = ['Hispanic or Latino']

export const EthnicitySelector = ({
  criteria = 'Must',
  segment,
  onChange,
}: {
  criteria: string
  onChange: (criteria: string, segmentName: string, value: any, operation?: string) => void
  segment: object
}) => {
  const currentValues = getSegmentValue(segment, criteria, SegmentName)
  const isHispanicEthnicity = currentValues.includes(true)
  return (
    <Box>
      <Box pb={1}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className="title"
        >
          Ethnicity
        </Typography>
      </Box>
      <CheckList
        selectedValues={isHispanicEthnicity ? ['Hispanic or Latino'] : []}
        values={ETHNICITY_OPTIONS}
        labels={ETHNICITY_OPTIONS}
        onChange={(values) => {
          const value: boolean[] = []
          if (values.includes('Hispanic or Latino')) {
            value.push(true)
          }
          onChange(criteria, SegmentName, value, 'in')
        }}
      />
    </Box>
  )
}

export default withContext(EthnicitySelector)
